/// <reference path="../app.ts" />
namespace Advant.Crossroads {
    "use strict";

    interface IApplicationExportProjectsScope extends angular.IScope {
        vm: ApplicationExportProjects;
    }

    interface IApplicationExportProjects {
        log: (msg, data?, showHowl?) => void;
        logError: (msg, data?, showHowl?) => void;
        logSuccess: (msg, data?, showHowl?) => void;
        loadingProjects: boolean;
        projects: IApplicationExportProject[];
        currentProject: IApplicationExportProject;
        page: number;
        pageSize: number;
        totalCount: number;
        sortBy: string;
        sortDirection: string;
        totalPages: number;
        startRow: number;
        endRow: number;
        searchFilter: string;
    }

    class ApplicationExportProjects implements IApplicationExportProjects {
        static controllerId: string = "applicationExportProjects";
        static $inject = ["$scope", "$location", "dialogs", "Restangular", "common", "config", "helper"];

        log: (msg, data?, showHowl?) => void;
        logError: (msg, data?, showHowl?) => void;
        logSuccess: (msg, data?, showHowl?) => void;
        loadingProjects: boolean;
        projects: IApplicationExportProject[];
        currentProject: IApplicationExportProject;
        page: number;
        pageSize: number;
        totalCount: number;
        sortBy: string;
        sortDirection: string;
        totalPages: number;
        startRow: number;
        endRow: number;
        searchFilter: string;

        constructor(private $scope: IApplicationExportProjectsScope,
            private $location: angular.ILocationService,
            private dialogs: angular.dialogs.IDialogService,
            private Restangular: Restangular.IService,
            private common: ICommonService,
            private config: ICrossroadsConfig,
            private helper: IHelper) {
            this.log = common.logger.getLogFn(ApplicationExportProjects.controllerId);
            this.logError = common.logger.getLogFn(ApplicationExportProjects.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(ApplicationExportProjects.controllerId, "success");

            this.loadingProjects = false;

            this.page = 1;
            this.pageSize = 25;
            this.sortBy = "Name";
            this.sortDirection = "ASC";
            this.searchFilter = "";

            this.$scope.$on(config.events.applicationChanged, (event) => {
                this.activate();
            });

            this.activate();
        }

        private activate() {
            var self = this;
            this.common.activateController([this.getProjects()], ApplicationExportProjects.controllerId)
                .then((result) => {
                self.log("Activated Application Export Projects View");
                return result;
            });
        }

        createNewProject() {
            this.$location.path("/application/export/projects/applicationExportProjects/new");
        }

        deleteProject = () => {
            var confirm = this.dialogs.confirm("Delete Project", "Are you sure you want to delete this project?");

            confirm.result.then((button) => {
                return this.currentProject.remove().then((result) => {
                    this.getProjects();
                    return result;
                }, (reason) => {
                    if (reason.status === 400) {
                        if (reason.data.modelState) {
                            for (var state in reason.data.modelState) {
                                if (state !== "$type") {
                                    this.logError(reason.data.modelState[state], reason.data.modelState[state], true);
                                }
                            }
                        }
                        else {
                            this.logError("An error occurred while deleting the export project", reason, true);
                        }
                    }
                    else {
                        this.logError("An error occurred while deleting the export project", reason, true);
                    }
                        return;
                    });
            });
        };

        editProject = () => {
            var userInfo = this.common.getUser();

            if (userInfo["canCreateAppExports"]) {
                this.$location.path(`/application/export/projects/${this.currentProject.id}`);
            } else {
                this.$location.path(`/application/export/projects/${this.currentProject.id}/download`);
            }
        };

        getProjects = (): angular.IPromise<void | Array<IExportProject>> => {
            this.loadingProjects = true;
            this.projects = [];
            this.currentProject = null;

            var queryParams = {
                page: this.page,
                pageSize: this.pageSize,
                sortBy: this.sortBy,
                sortDirection: this.sortDirection,
                filter: this.searchFilter

            };

            return this.Restangular.one(this.common.getUser().activeApplication).getList("applicationExportProjects", queryParams).then((result: IRestangularResult<IExportProject>) => {
                this.projects = result;

                this.totalCount = result.totalCount;
                this.totalPages = result.totalPages;

                if (result.totalCount > 0) {
                    this.startRow = this.page === 1 ? 1 : (this.pageSize * (this.page - 1)) + 1;
                    this.endRow = (this.startRow - 1) + result.length;
                } else {
                    this.startRow = 0;
                    this.endRow = 0;
                }
                this.loadingProjects = false;
                this.getShareCount();
                return result;
            }, (reason) => {
                    this.loadingProjects = false;
                    this.logError("An error occurred while getting the export projects", reason);
                });
        };

        searchExportProjects = (): void => {
            this.common.debouncedThrottle("ApplicationExportProjectsSearch", () => { this.page = 1; this.getProjects(); }, 400);
        };

        sort = (sortValue: string): void => {
            if (this.sortBy === sortValue) {
                this.sortDirection = this.sortDirection === "ASC" ? "DESC" : "ASC";
            } else {
                this.sortBy = sortValue;
            }
            this.page = 1;
            this.getProjects();
        };


        share = (project: IApplicationExportProject) => {
            this.dialogs.create("/app/exportProjects/shareExportProject.html", ShareExportProject.controllerId, project).closed.then(() => {
                this.getShareCount();
            });
            
        };

        getShareCount = () => {
            var projectIds = _.map(this.projects, "id");
            this.Restangular.all("applicationExportProjects/shared/count").post(projectIds).then(
                (result) => {
                    this.projects.forEach((project) => {
                        var t: any = _.find(result, { exportProjectId: project.id })
                        project.shareCount = t.count;
                    })

                    console.log(this.projects);

                }, (reason) => {
                    this.logError("An error occurred while getting the export projects", reason);
                });
        };
    }


    angular.module("app").controller(ApplicationExportProjects.controllerId, ApplicationExportProjects);
}